export default __webpack_public_path__ + "static/media/Team-Captain-Coach.89f8590c.gif";